import { useBookableResourcesQuery, useLimitsQuery } from '../../lib/Queries';
import LimitsAdvanceTime from './LimitsAdvanceTime.jsx';
import LimitsDailyMax from './LimitsDailyMax.jsx';
import LimitResourceConstraints from './LimitResourceConstraints.jsx';
import LimitsClientMax from './LimitsClientMax.jsx';

const Limits = ({ className }) => {
    const { data, isLoading } = useLimitsQuery();
    const { data: bookableResources } = useBookableResourcesQuery();

    const showResourceLimit = !!data?.resource || bookableResources?.length > 1;

    console.log('all limits=', data);

    return (
        <div className={className}>
            <div className="panel-label">Limits</div>
            <div className="panel px-6 py-3">
                <LimitsAdvanceTime limit={data?.advance} />
            </div>

            <div className="panel px-6 py-3 mt-4">
                <LimitsDailyMax limit={data?.daily} />
            </div>

            <div className="panel px-6 py-3 mt-4">
                <LimitsClientMax limit={data?.client} />
            </div>

            {showResourceLimit && (
                <div className="panel px-6 py-3 mt-4">
                    <LimitResourceConstraints limit={data?.resource} />
                </div>
            )}
        </div>
    );
};

export default Limits;
